import React from "react";
import Link from "../ui/RouterLink";
import { resolveTrackArtists } from "../utils";

export default function SetTrackArtists({ track }) {
  const artists = resolveTrackArtists(track);
  if (!artists.length) return null;
  return (
    <div className="track-subtitle">
      {artists.map((artist, index) => (
        <React.Fragment key={artist.id ?? `${artist.name}-${index}`}>
          {index > 0 && ", "}
          {artist.id != null ? (
            <Link className="set-track-artist" to={`/artist/${artist.id}`}>
              {artist.name}
            </Link>
          ) : (
            artist.name
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
